import RandingStyle19 from "../../randing/RandingStyle19";

function Randing177({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle19
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="3"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/177/1-1.gif`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/143/2-1.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/177/3-1.png`}
      changedIMG={`${process.env.REACT_APP_CDN_BASE}/images/017/01_241101_03.jpg`} // 스텝 변경되는 이미지
      numberColor="#201c54"
      qOptionColor="blue"
      qOptionColor2="age"
      qTitleColor="#204cec"
      formFieldColor="white"
      audioOn={true}
      passBTN={`${process.env.REACT_APP_CDN_BASE}/images/165/1-2.png`}
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/165/2-2.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton4.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori.jpg`}
      randingNumber="177"
    />
  );
}

export default Randing177;
